import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import moment from "moment";

let apiClient = ApiClient.getInstance();
const TODAY = moment(new Date()).format('YYYY-MM-DD');
const headersDataTable = [
    { title: "Clave", value: true },
    { title: "Estado", value: true },
    { title: "Tipo Carta", value: true },
    { title: "Version", value: true },
    { title: "No. Documento", value: true },
    { title: "CardCode", value: true },
    { title: "Transporte", value: true },
    { title: "FiguraTransporte", value: true },
    { title: "Usuario", value: true },
    { title: "Folio", value: true },
];

class CartaPorteView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
        }
    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liCartaPorte");
        const filter = {
            initDate: moment().subtract(15, 'days').format('YYYY-MM-DD'),
            finalDate: TODAY,
            docType: '-',
        }
        await this.callDocumentsListService(filter);
    }

    searchCartaPorte = async filter => {
        await this.callDocumentsListService(filter);
    };

    callDocumentsListService = async (filters) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        const cartaPorteResponse = await apiClient.getCartaPorteList(filters);
        enableSpinner(false);

        if (cartaPorteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            if (cartaPorteResponse.data.manager.length === 0) {
                showAlert({ type: 'info', timeOut: 5000, message: "No se encontraron resultados correspondientes a la búsqueda." });
            }

            this.setState({
                data: cartaPorteResponse.data.manager,
                total: cartaPorteResponse.data.totalRows
            });
        }

    };

    render() {
        const { headers, data, total } = this.state;
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} _user={this.state._user} />
                <TimeOut />
                <BreadCumb subitem1={'CARTA PORTE'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <label id="liCartaPorte" className="text-muted">
                            &nbsp;CARTA PORTE 3.1
                        </label>
                    </h2>

                    <DataTables
                        headers={headers}
                        view={"consignmentNote"}
                        data={data}
                        search={this.searchCartaPorte}
                        totalRows={total}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartaPorteView);